import { ReactComponent as AgencyRecruitmentIcon } from "../../icons/agency-recruitment.svg";
import { ReactComponent as TalkToOurExpertsIcon } from "../../icons/talk-to-our-experts.svg";
import { ReactComponent as DjangoIcon } from "../../icons/frameworks/django.svg";
import { ReactComponent as DrupalIcon } from "../../icons/frameworks/drupal.svg";
import { ReactComponent as MagentoIcon } from "../../icons/frameworks/magento.svg";
import { ReactComponent as LaravelIcon } from "../../icons/frameworks/laravel.svg";
import { ReactComponent as NextjsIcon } from "../../icons/frameworks/nextjs.svg";
import { ReactComponent as GoIcon } from "../../icons/languages/go.svg";
import { ReactComponent as JavaIcon } from "../../icons/languages/java.svg";
import { ReactComponent as NodejsIcon } from "../../icons/languages/nodejs.svg";
import { ReactComponent as PhpIcon } from "../../icons/languages/php.svg";
import { ReactComponent as PythonIcon } from "../../icons/languages/python.svg";
import { ReactComponent as RubyIcon } from "../../icons/languages/ruby.svg";
import { ReactComponent as WordpressIcon } from "../../icons/frameworks/wordpress.svg";
import { ReactComponent as SymfonyIcon } from "../../icons/frameworks/symfony.svg";
import { ReactComponent as AgencyPortalIcon } from "../../icons/agency-portal.svg";

const headerData = {
  homepage: "/",
  top: [
    {
      text: "Contact us",
      href: "/contact-us/",
    },
    {
      text: "Docs",
      href: "https://devcenter.upsun.com/",
    },
    {
      text: "Login",
      href: "https://auth.upsun.com/",
    },
  ],
  links: [
    {
      text: "Product",
      columns: [
        {
          title: "Product",
          links: [
            {
              text: "Overview",
              href: "/product/"
            },
            {
              text: "Features",
              href: "/features/"
            },
          ]
        },
        {
          title: "Frameworks",
          links: [
            {
              text: "Django",
              href: "/django/",
              icon: <DjangoIcon />
            },
            {
              text: "Next.js",
              href: "/nextjs/",
              icon: <NextjsIcon />
            },
            {
              text: "Drupal",
              href: "/drupal/",
              icon: <DrupalIcon />
            },
            {
              text: "WordPress",
              href: "/wordpress/",
              icon: <WordpressIcon />
            },
            {
              text: "Symfony",
              href: "/symfony/",
              icon: <SymfonyIcon />
            },
            {
              text: "Magento",
              href: "/magento/",
              icon: <MagentoIcon />
            },
            {
              text: "Laravel",
              href: "/laravel/",
              icon: <LaravelIcon />
            }
          ]
        },
        {
          title: "Languages",
          links: [
            {
              text: "PHP",
              href: "/php/",
              icon: <PhpIcon />
            },
            {
              text: "Python",
              href: "/python/",
              icon: <PythonIcon />
            },
            {
              text: "Node.js",
              href: "/nodejs/",
              icon: <NodejsIcon />
            },
            {
              text: "Ruby",
              href: "/ruby/",
              icon: <RubyIcon />
            },
            {
              text: "Java",
              href: "/java/",
              icon: <JavaIcon />
            },
            {
              text: "Golang",
              href: "/go/",
              icon: <GoIcon />
            }
          ]
        }
      ]
    },
    {
      text: "Solutions",
      columns: [
        {
          title: "Solutions",
          links: [
            {
              text: "SaaS hosting",
              href: "/solutions/saas/"
            },
            {
              text: "Application modernization",
              href: "/solutions/application-modernization/"
            },
            {
              text: "eCommerce hosting",
              href: "/solutions/ecommerce/"
            },
            {
              text: "CMS hosting",
              href: "/solutions/cms/"
            },
            {
              text: "Multi site management",
              href: "/solutions/multi-site-management/"
            },
            {
              text: "SaaS extensions",
              href: "/solutions/saas-extensions/"
            },
            {
              text: "Backend solutions",
              href: "/solutions/backend/"
            },
          ]
        },
        {
          title: "Industry",
          links: [
            {
              text: "Retail",
              href: "/industry/retail/"
            },
            {
              text: "Higher education",
              href: "/industry/higher-education/"
            },
            {
              text: "SaaS",
              href: "/industry/saas/"
            },
            {
              text: "Travel and hospitality",
              href: "/industry/travel-and-hospitality/"
            },
            {
              text: "Financial Services",
              href: "/industry/financial-services/"
            },
            {
              text: "Government",
              href: "/industry/government/"
            },
          ]
        }
      ]
    },
    {
      text: "Pricing",
      columns: [
        {
          title: "Plans",
          links: [
            {
              text: "Flexible resources",
              href: "/pricing/"
            },
            {
              text: "Fixed resources",
              href: "/fixed-pricing/"
            },
          ]
        }
      ]
    },
    {
      text: "Partners",
      emphasizeFirstCol: true,
      columns: [
        {
          title: "Expertise",
          links: [
            {
              "text": "Strategic Implementation",
              "href": "/strategic-implementation-experts/",
              "desc": "Tap upsun's implementation architects for the clarity and technical pathways that turn complex projects into confident launches.",
              "cta": "See how we can help"
            }
          ]
        },
        {
          title: "",
          links: [
            {
              "text": "Get implementation help",
              "href": "/strategic-implementation-experts/",
              "icon": <TalkToOurExpertsIcon />
            },
            {
              "text": "Become an agency partner",
              "href": "/agency-hosting-partner/",
              "icon": <AgencyRecruitmentIcon />
            },
            {
              "text": "Log to your portal",
              "href": "https://agencypartner.platform.sh",
              "icon": <AgencyPortalIcon /> 
            },
          ]
        }
      ]
    },
    {
      text: "Company",
      emphasizeFirstCol: true,
      columns: [
        {
          "title": "Community",
          "links": [
            {
              "text": "Developer center",
              "href": "https://devcenter.upsun.com/",
              "desc": "Hub for the latest Upsun dev resources: find demos, docs, and articles for your chosen frameworks and languages",
              "cta": "Check it out",
            },
          ]
        },
        {
          "title": "Resources",
          "links": [
            {
              "text": "Case studies",
              "href": "/blog/case-studies"
            },
            {
              "text": "Blog",
              "href": "/blog/"
            },
            {
              "text": "Trust center",
              "href": "/trust-center/"
            },
          ]
        },
        {
          "title": "Overview",
          "links": [
            {
              "text": "Events",
              "href": "/events/",
            },
            {
              "text": "News and press",
              "href": "/blog/news/"
            },
            {
              "text": "About us",
              "href": "/about-us/",
            },
            {
              "text": "Jobs",
              "href": "/jobs/"
            },
            {
              "text": "Sustainability",
              "href": "/greener-hosting/",
            },
            {
              "text": "FAQ",
              "href": "/faq/",
            }
          ]
        }
      ]
    },
  ],
  ctas: [
    {
      text: "Watch a demo",
      href: "/demo/",
    },
    {
      text: "Free trial",
      href: "https://auth.upsun.com/register",
    },
  ],
}

export default headerData;